module.exports = __webpack_public_path__ + "img/jr_bg.fce15725.jpg";